import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { base_url } from "../../../config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PhoneInput = ({ onOtpSent, onOtpVerified }) => {

  // console.log("====>log",window.location.search.includes("user_type=NO_HOST") ? "NO_HOST" : null)
  const [phone, setPhone] = useState(localStorage.getItem("@userPhone") || "");
  const [otpSent, setOtpSent] = useState(false);
  const [isSignup, setIsSignup] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [city, setCity] = useState(null);
  const inputRefs = useRef([]);

  const htCities = [
    'Bangalore',
    'Delhi',
    'Kochi'
  ]

  const handlePhoneChange = (e) => {
    let value = e.target.value;
    // Allow only numbers
    value = value.replace(/[^0-9]/g, '');
    // Remove leading "0" if phone starts with it
    if (value.startsWith("0")) {
      value = value.substring(1);
    }
    setPhone(value);
  };

  const handleOtpChange = (index, value) => {
    if (value.length > 1) {
      // Handle paste event
      const otpArray = value.split("").slice(0, 4);
      setOtp(otpArray);
      otpArray.forEach((digit, idx) => {
        if (inputRefs.current[idx]) {
          inputRefs.current[idx].value = digit;
        }
      });
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to the next input box if value is entered
    if (value && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      // Move to the previous input box on backspace
      inputRefs.current[index - 1]?.focus();
    }
  };

  const sendOtp = async () => {

      let processedPhone = phone;
        if (processedPhone.length === 11 && processedPhone.startsWith("0")) {
          processedPhone = processedPhone.substring(1);
        }

    let userType = window.location.search.includes("user_type=NO_HOST") ? "NO_HOST" : null;
    if(city != 'Bangalore') userType = null;
    
    const body = {
      phone: processedPhone, // Use the processed value
      client_id: "CLIENT002",
      client_secret: "5PY02KdOpCX5FO93jSjPa7gKsBvQF",
      grant_type: "password",
      device_id: "66220660-112c-2721-6d10-67eab548a8c8",
      device_type: "web",
      user_type: userType,
    };

    try {
      const { data } = await axios.post(
        `${base_url}/users/login-otp`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("OTP sent successfully:", data);
      setOtpSent(true);
      if(data?.signup || city === 'Bangalore'){
        setIsSignup(true);
      }
     
      if (onOtpSent) onOtpSent();
      toast.success("OTP sent successfully!");
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Failed to send OTP. Please try again.");
    }
  };
const navigate = useNavigate();
  const fetchProfileData = async (accessToken) => {
    try {
      const response = await axios.get(
        `${base_url}/profile-members/profile`,
        {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // console.log("Profile Data:", response.data.data);
      localStorage.setItem("@userAccount", response.data.data.id);
      localStorage.setItem("@userName", response.data.data.first_name);
      localStorage.setItem("@userPhone", response.data.data.phone);
      localStorage.setItem("@userPhoto", response.data.data.photo);
      localStorage.setItem("email", response.data.data.email);
      localStorage.setItem("gender", response.data.data.gender);
      localStorage.setItem("userType", response.data.data.user_type);
     if(isSignup){
             if (onOtpVerified) onOtpVerified();
      } else {
        navigate("/");
        window.location.reload();
      }
      
        
    } catch (error) {
      console.error("Failed to fetch profile data:", error);
      localStorage.removeItem("@user");
      localStorage.removeItem("@userRefreshToken");
      localStorage.removeItem("@userName");
      localStorage.removeItem("@userPhone");
      localStorage.removeItem("@userAccount");
      localStorage.removeItem("@userPhoto");
    }
  };
  const verifyOtp = async () => {

    let userType = window.location.search.includes("user_type=NO_HOST") ? "NO_HOST" : null;
    if(city != 'Bangalore') userType = null;
    
    const body = {
      client_id: "CLIENT002",
      client_secret: "5PY02KdOpCX5FO93jSjPa7gKsBvQF",
      login_type: "phone",
      grant_type: "password",
      otp_verify: otp.join(""),
      phone: phone,
      device_id: "66220660-112c-2721-6d10-67eab548a8c8",
      device_type: "web",
      user_type: userType,
    };

    try {
      const { data } = await axios.post(
        `${base_url}/users/login-otp`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("OTP verified successfully:", data);
        console.log("Auth Token Response:", data.access_token);
        
      toast.success("OTP verified successfully!");
    
      fetchProfileData(data.access_token);
      localStorage.setItem("@user", data.access_token);
      localStorage.setItem("@userRefreshToken", data.refresh_token);
      localStorage.setItem("@tokenExpiry", data.expires_in);
      localStorage.setItem("@userPhone", phone); // Save phone number after OTP verification
      
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("Failed to verify OTP. Proceeding to the next question.");
    }
   
  };

  return (
    <div className="phone-input-container sm:w-[30rem] ">
      {!otpSent ? (
        <>
          <div>
            <label htmlFor="city" className="block text-sm font-medium mb-2">
              Where are you located:
            </label>

            <select
              id="city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              className={`w-full p-2 border border-gray-200 rounded-xl text-xl 
    ${!city ? "text-gray-400" : "text-black"}`}
            >
              <option value="" hidden>
                Select your city
              </option>

              {htCities.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </div>

        <div>
          <label htmlFor="phone" className="block text-sm font-medium mb-2 mt-6">
            Enter Phone Number:
          </label>
          <input
            type="tel"
            id="phone"
            value={phone}
            onChange={handlePhoneChange}
            placeholder="Enter your phone number"
            className="w-full p-2 border border-gray-200 rounded-xl text-xl"
          />
          <button
            onClick={sendOtp}
            disabled={!city || !phone.trim()}
            className={`mt-4 px-4 py-3 rounded-2xl w-56 ${
              !city || !phone.trim() 
                ? 'bg-gray-400 text-gray-600 cursor-not-allowed' 
                : 'bg-black text-white'
            }`}
          >
            Send OTP
          </button>
        </div>
        </>
      ) : (
        <div>
          <label htmlFor="otp" className="block text-sm font-medium mb-2">
            Enter OTP:
          </label>
          <div className="flex justify-start gap-4 mt-2 space-x-">
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                ref={(el) => (inputRefs.current[index] = el)}
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="w-16 h-16 text-center border rounded-lg text-lg text-black"
                maxLength={1}
              />
            ))}
          </div>
          <button
            onClick={verifyOtp}
            className="mt-4 px-4 py-3 bg-black text-white rounded-2xl w-56"
          >
            Verify OTP
          </button>
        </div>
      )}
    </div>
  );
};

PhoneInput.propTypes = {
  onOtpSent: PropTypes.func,
  onOtpVerified: PropTypes.func,
};

export default PhoneInput;